export default __webpack_public_path__ + "static/media/logoen-indiapolls.67d218aa.png";